import React, { Children } from "react";
import PropTypes from "prop-types";
import { Container } from "@ui/wrapper";
import SectionTitle from "@ui/section-title";
import Tabs, { Tab } from "@ui/tabs";
import { SectionTitleType } from "@utils/types";
import { graphql, useStaticQuery } from "gatsby";
import { convertToBgImage } from "gbimage-bridge";
import { getImage } from "gatsby-plugin-image";
import { AboutTabAreaWrapper, StyledTab } from "./style";

const AboutTabArea = ({ id, data, children }) => {
    const childArr = Children.toArray(children);

    const aboutBg = useStaticQuery(graphql`
        query AboutQuery {
            file(relativePath: { eq: "bg/about-us-bg.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        layout: FULL_WIDTH
                        placeholder: TRACED_SVG
                        formats: WEBP
                        quality: 100
                    )
                }
            }
        }
    `);
    const bgImage = convertToBgImage(getImage(aboutBg.file));

    return (
        <AboutTabAreaWrapper id={id} {...bgImage}>
            <StyledTab>
                <Container>
                    {data?.section_title && (
                        <SectionTitle
                            mb={["50px", null, null, "60px"]}
                            title={data.section_title?.title}
                            subtitle={data.section_title?.subtitle}
                        />
                    )}
                    <Tabs defaultActiveKey={childArr[0].props.data.id}>
                        {childArr.map((item) => (
                            <Tab
                                key={item.props.data.id}
                                eventKey={item.props.data.id}
                                title={item.props.data.title}
                            >
                                {item}
                            </Tab>
                        ))}
                    </Tabs>
                </Container>
            </StyledTab>
        </AboutTabAreaWrapper>
    );
};

AboutTabArea.propTypes = {
    id: PropTypes.string,
    data: PropTypes.shape({
        section_title: PropTypes.shape(SectionTitleType),
    }),
    children: PropTypes.node.isRequired,
};

export default AboutTabArea;
